// src/Terms.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>

      <p className="mb-4">
        <strong>Effective Date:</strong> August 8, 2025
      </p>

      <p className="mb-6">
        Welcome to <strong>PlaysWithGuru</strong> (“<em>we</em>,” “<em>us</em>,” or “<em>our</em>”).
        By accessing or using our website, apps, or services (collectively, the “<em>Services</em>”),
        you agree to these Terms of Service and our{" "}
        <Link to="/privacy-policy" className="text-blue-600 underline">
          Privacy Policy
        </Link>
        . If you do not agree, do not use the Services.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">1. Nature of Content & Predictions</h2>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>
          Our content includes data, analysis, and predictions/tags (“Content”) provided for
          informational and entertainment purposes only.
        </li>
        <li>
          We make <strong>no guarantee</strong> of accuracy, completeness, or reliability of any
          Content, including outcomes related to sports, fantasy, or markets.
        </li>
        <li>
          Nothing in the Services is financial, investment, or gambling advice, nor a recommendation
          to place bets or make trades. You are solely responsible for any actions you take.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-2">2. Eligibility & Account</h2>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>You must be able to form a binding contract to use the Services.</li>
        <li>You’re responsible for safeguarding your account and not sharing credentials.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-2">3. Subscription & Payment Terms</h2>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>
          <strong>Billing:</strong> Subscriptions are billed in advance on a recurring basis
          (monthly/quarterly/annually as selected).
        </li>
        <li>
          <strong>Auto-Renewal:</strong> Subscriptions renew automatically at the then-current rate
          unless cancelled before the renewal date.
        </li>
        <li>
          <strong>Cancellations:</strong> You can cancel anytime in your account settings; access
          remains until the end of the paid term.
        </li>
        <li>
          <strong>Refunds:</strong> Payments are <strong>non-refundable</strong> unless required by
          law.
        </li>
        <li>
          <strong>Price Changes:</strong> We may change fees with advance notice. Continued use after
          the change constitutes acceptance.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-2">4. Acceptable Use</h2>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>No unlawful, infringing, or abusive use of the Services.</li>
        <li>No scraping, data mining, reverse engineering, or unauthorized extraction of Content.</li>
        <li>No reselling, sublicensing, or sharing of subscription access.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-2">5. Intellectual Property</h2>
      <p className="mb-6">
        The Services and Content are protected by intellectual property laws. Except as expressly
        allowed, you may not copy, modify, distribute, or create derivative works without our
        written consent.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">6. Disclaimers</h2>
      <p className="mb-6">
        The Services are provided <strong>“as is”</strong> and <strong>“as available”</strong> without
        warranties of any kind, express or implied, including merchantability, fitness for a
        particular purpose, and non-infringement. We do not warrant that the Services will be
        error-free or uninterrupted.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">7. Limitation of Liability</h2>
      <p className="mb-6">
        To the maximum extent permitted by law, PlaysWithGuru, its owners, and affiliates will not be
        liable for any indirect, incidental, consequential, special, exemplary, or punitive damages,
        or any loss of profits, revenue, data, or use, arising out of or related to your use of the
        Services or Content (including outcomes in betting, trading, or fantasy).
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">8. Governing Law & Venue</h2>
      <p className="mb-6">
        These Terms are governed by the laws of the State of Texas, without regard to conflicts of
        law. Exclusive jurisdiction and venue lie in the state or federal courts located in Harris
        County, Texas.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">9. Changes to Terms</h2>
      <p className="mb-6">
        We may update these Terms from time to time. Material changes will be posted to this page
        with a new effective date. Continued use of the Services after changes take effect
        constitutes acceptance.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">10. Contact</h2>
      <p className="mb-2">
        Questions about these Terms? Email{" "}
        <a href="mailto:playswithguru@gmail.com" className="text-blue-600 underline">
          playswithguru@gmail.com
        </a>
        .
      </p>
    </div>
  );
}
